import classNames from 'classnames';
import Buttons, { type ButtonProps } from 'components/Buttons/Buttons';
import React, { type ReactElement } from 'react';

import { useCopyToClipboard } from '@/hooks/useCopyToClipboard';

import s from './CopyButton.module.scss';

type Props = ButtonProps & {
  onCopyError?: (error: unknown) => void;
  onCopySuccess?: () => void;
  text: string;
  children: React.ReactNode;
};

const CopyButton = ({ onCopyError, onCopySuccess, text, children = 'Copy', ...restProps }: Props): ReactElement => {
  const copyToClipboard = useCopyToClipboard();

  const copy = async (): Promise<void> => {
    try {
      const didCopy = await copyToClipboard(text, 'Copied to clipboard!');
      if (!didCopy) {
        onCopyError?.(new Error('Failed to copy to clipboard'));
        return;
      }
      onCopySuccess?.();
    } catch (e) {
      onCopyError?.(e);
    }
  };

  const handleClick = (): void => {
    void copy();
  };

  return (
    <Buttons
      className={classNames(!restProps.isPrimary && !restProps.isSecondary && s.copy)}
      {...restProps}
      onClick={handleClick}
    >
      {children}
    </Buttons>
  );
};

export default CopyButton;
